import { Button, Text } from 'frosted-ui';
import { FIRST_RUN_STEPS, type FirstRunStep } from './firstRun';

interface FirstRunHeaderProps {
  step: FirstRunStep;
  progress: number;
  onSkip: () => void;
}

/** The one step label + progress bar every first-run page shows. */
export default function FirstRunHeader({ step, progress, onSkip }: FirstRunHeaderProps) {
  const percent = Math.round(Math.min(Math.max(progress, 0), 1) * 100);

  return (
    <nav
      aria-label="Getting started"
      style={{
        maxWidth: 1040,
        width: '100%',
        margin: '0 auto var(--space-5)',
        display: 'flex',
        flexDirection: 'column',
        gap: 'var(--space-2)',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 'var(--space-3)',
        }}
      >
        <Text size="2" weight="medium" color="gray" aria-current="step">
          Step {step} of {FIRST_RUN_STEPS.length} · {FIRST_RUN_STEPS[step - 1]}
        </Text>
        <Button
          variant="ghost"
          color="gray"
          size="2"
          onClick={onSkip}
          style={{ minHeight: 44, flexShrink: 0 }}
        >
          Skip setup
        </Button>
      </div>
      <div
        role="progressbar"
        aria-label="Setup progress"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={percent}
        style={{
          width: '100%',
          height: 4,
          backgroundColor: 'var(--gray-a4)',
          borderRadius: 4,
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            height: '100%',
            width: `${percent}%`,
            backgroundColor: 'var(--iris-9)',
            borderRadius: 4,
            transition: 'width 420ms cubic-bezier(0.2, 0.8, 0.25, 1)',
          }}
        />
      </div>
    </nav>
  );
}
